import { render, staticRenderFns } from "./eb-checkbox.vue?vue&type=template&id=e7480384&"
import script from "./eb-checkbox.vue?vue&type=script&lang=js&"
export * from "./eb-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports